import { ArdoqId } from '@ardoq/api-types';
import { FilterModel } from '../filters/types';
import {
  ExpandedAll,
  CollapsedAll,
  PartiallyExpanded,
  InventoryHierarchyExpansion,
} from '../types';

const isExpandedAll = (
  expansion: InventoryHierarchyExpansion
): expansion is ExpandedAll => expansion.type === 'expandedAll';

const isCollapsedAll = (
  expansion: InventoryHierarchyExpansion
): expansion is CollapsedAll => expansion.type === 'collapsedAll';

const isPartiallyExpanded = (
  expansion: InventoryHierarchyExpansion
): expansion is PartiallyExpanded => expansion.type === 'partiallyExpanded';

const getExpandedAll = (): ExpandedAll => ({
  type: 'expandedAll',
});

const getCollapsedAll = (
  filterSnapshotAtCollapseTime: FilterModel
): CollapsedAll => ({
  type: 'collapsedAll',
  filterSnapshotAtCollapseTime,
});

const getPartiallyExpanded = (
  expandedNodeIds: Set<ArdoqId> = new Set()
): PartiallyExpanded => ({
  type: 'partiallyExpanded',
  expandedNodeIds,
});

export const inventoryHierarchyExpansionOperations = {
  isExpandedAll,
  isCollapsedAll,
  isPartiallyExpanded,
  getExpandedAll,
  getCollapsedAll,
  getPartiallyExpanded,
};
